import type { FirestoreTimestamp, Platform } from '../common'

export namespace CoreUser {
  export namespace RegistrationToken {
    export enum Permission {
      NotDetermined = 'not_determined',
      Denied = 'denied',
      Authorized = 'authorized',
      Provisional = 'provisional',
      Ephemeral = 'ephemeral',
      Enabled = 'enabled',
      NotEnabled = 'not_enabled',
    }
  }

  export type RegistrationToken<TApp extends string> = {
    app: TApp
    app_version_code?: number
    app_version_name?: string
    appsflyer_id?: string
    device_manufacturer?: string
    device_model?: string
    att?: number
    fid?: string
    gaid?: string
    idfa?: string
    os_version?: string
    permission?: RegistrationToken.Permission
    platform: Platform
    timestamp: FirestoreTimestamp
    token: string
  }

  export namespace Subscription {
    export enum Gateway {
      AppStore = 'appstore',
      Fastspring = 'fastspring',
      Flex = 'flex',
      GooglePlay = 'google_play',
      Huawei = 'huawei',
      Paddle = 'paddle',
      Stripe = 'stripe',
    }
  }

  export type Subscription<TTier extends string | undefined> = {
    active?: boolean
    tier?: TTier
    product_id: string
    expires?: FirestoreTimestamp | number | null
    created: FirestoreTimestamp
    canceled?: FirestoreTimestamp
    flex_subscription?: string
    flex_email?: string
    gateway?: string
    purchase_token?: string | null
    receipt?: string | null
    jws_transaction?: string | null
    huawei_purchase_token?: string | null
    fastspring_subscription?: string | null
    subscription_id?: string | null
    paddle_subscription?: string
    paddle_email?: string
    stripe_subscription?: string
    price?: string
    currency_code?: string
    country_code?: string
    introductory_price_currency_code?: string
    introductory_price_amount_micros?: string
    introductory_price_period?: string
    introductory_price_cycles?: number
    appsflyer_id?: string
    original_transaction_id?: string
  }

  export interface CustomClaims {
    role: Role
  }

  export enum Role {
    Admin = 'admin',
  }
}

export interface CoreUser {
  registered?: FirestoreTimestamp
}
